import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var COLORS = ['007BE7', '40A0F4', '645EFE', '5AB3FF', '4EC4FF', '4C00DC', '763EF4'];

/**
 * Given a name, extracts initials and generates a fallback avatar url.
 */
export function generateAvatarFallback(name) {
  if (!name) {
    return null;
  }
  var initials = getInitials(name);
  var color = COLORS[initials.charCodeAt(0) % COLORS.length];
  return "https://dummyimage.com/128/".concat(color, "/fff.png?text=+").concat(initials, "+");
}
function getInitials(str) {
  if (str.indexOf('@') > -1) {
    // It's an email, take the first and last part.
    var _exec = /(.*?)@(.*)/.exec(str),
      _exec2 = _slicedToArray(_exec, 3),
      user = _exec2[1],
      domain = _exec2[2];
    return "".concat(user.charAt(0)).concat(domain.charAt(0));
  }
  var _str$split = str.split(' '),
    _str$split2 = _slicedToArray(_str$split, 2),
    first = _str$split2[0],
    last = _str$split2[1];
  if (!last) {
    return first.charAt(0);
  }
  return "".concat(first.charAt(0)).concat(last.charAt(0));
}
//# sourceMappingURL=dummyImageUtil.js.map
